<template>
  <div>
    <el-dialog
      title="指定物流"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="发货逻辑仓名称">
          <BjInput v-model="form.stockWarehouseName" disabled class="input-default-width" />
        </el-form-item>
        <el-form-item label="选择物流" prop="defaultLogisticsFlag">
          <el-radio-group v-model="form.defaultLogisticsFlag" @change="onRadio">
            <el-radio :label="false">指定物流商</el-radio>
            <el-radio :label="true">默认物流</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <template v-if="defaultLogistics != '{}' && "></template> -->
        <el-form-item
          label="指定物流商"
          prop="logisticCompanyCode"
          :rules="checkRules ? rules.logisticCompanyCode : {}"
        >
          <span v-show="list.length === 0 && !form.defaultLogisticsFlag">暂无可发该包裹的物流</span>
          <el-select
            v-show="!form.defaultLogisticsFlag && list.length > 0"
            v-model="form.logisticCompanyCode"
            :placeholder="$t('chooseText')"
            class="input-default-width"
            @change="changeCompanyId"
          >
            <el-option v-for="item in list" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
          <BjInput
            v-show="form.defaultLogisticsFlag && Object.keys(defaultLogistics).length > 0"
            v-model="form.logisticCompanyName"
            disabled
            class="input-default-width"
          />
          <span v-if="Object.keys(defaultLogistics).length === 0 && form.defaultLogisticsFlag"
            >{{ $t('table.emptyText') }}</span
          >
        </el-form-item>
        <el-form-item
          v-show="list.length > 0 || form.defaultLogisticsFlag"
          label="指定物流业务"
          prop="logisticBusinessCode"
          :rules="checkRules ? rules.logisticBusinessCode : null"
        >
          <el-select
            v-show="!form.defaultLogisticsFlag && list.length > 0"
            v-model="form.logisticBusinessCode"
            :disabled="!form.logisticCompanyCode"
            :placeholder="$t('chooseText')"
            class="input-default-width"
            @change="changeBusinessCode"
          >
            <el-option
              v-for="item in businessList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <BjInput
            v-show="form.defaultLogisticsFlag && Object.keys(defaultLogistics).length > 0"
            v-model="form.logisticBusinessName"
            disabled
            class="input-default-width"
          />
          <span v-if="Object.keys(defaultLogistics).length === 0 && form.defaultLogisticsFlag"
            >{{ $t('table.emptyText') }}</span
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button v-if="showLastBtn" type="primary" @click="onLast">上一步</el-button>
        <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { logisticApi, settingApi } from '@/api';
const getDefaultForm = () => {
  return {
    stockWarehouseId: null,
    stockWarehouseCode: null,
    stockWarehouseName: null,
    defaultLogisticsFlag: false,
    logisticCompanyId: null,
    logisticCompanyCode: null,
    logisticCompanyName: null,
    logisticBusinessId: null,
    logisticBusinessCode: null,
    logisticBusinessName: null,
  };
};
export default {
  name: 'BusinessOrderSourceAppointLogistics',
  props: {
    showLastBtn: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['areaCode'],
  data() {
    return {
      form: getDefaultForm(),
      rules: {
        defaultLogisticsFlag: [{ required: true, message: '请选择物流', trigger: 'change' }],
        logisticBusinessCode: [
          { required: true, message: '请选择指定物流业务', trigger: 'change' },
        ],
        logisticCompanyCode: [{ required: true, message: '请选择指定物流商', trigger: 'change' }],
      },
      dialogVisible: false,
      list: [],
      defaultLogistics: {},
      stockId: null,
      stockName: null,
      stockCode: null,
    };
  },
  computed: {
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticCompanyId, enableFlag: true };
    },
    businessList() {
      const business = this.list.find(item => item.code === this.form.logisticCompanyCode);
      return business ? business.businessList : [];
    },
    checkRules() {
      // 获取列表有数据
      return this.list.length || this.form.defaultLogisticsFlag;
    },
  },
  watch: {},
  methods: {
    show(info) {
      if (info.BJ_EBC_ID) {
        this.form = Object.assign({}, this.$lodash.clone(info));
        this.stockId = info.stockWarehouseId;
        this.stockName = info.stockWarehouseName;
        this.stockCode = info.stockWarehouseCode;
      } else {
        this.form = getDefaultForm();
        this.form.stockWarehouseId = this.stockId = info.stockId;
        // 发货仓名称
        this.form.stockWarehouseName = this.stockName = info.stockName;
        // 获取发货仓编码
        this.form.stockWarehouseCode = this.stockCode = info.stockNo;
      }

      this.dialogVisible = true;
      this.getData();
    },
    getData() {
      logisticApi
        .getQueryLogistics({
          areaCode: this.areaCode(),
          storehouseCode: this.form.stockWarehouseCode,
        })
        .then(res => {
          if (!res.failed) {
            this.list = res;
            // 获取默认物流
            settingApi.getStrategyLogistics().then(res => {
              if (!res.failed) {
                this.defaultLogistics = res.defaultLogistics;
                // 没有数据获取默认数据
                if (!this.list.length) {
                  this.setDefaultLogistics();
                }
              }
            });
            // 不是编辑状态根据返回数据修改
            if (!this.form.BJ_EBC_ID) {
              this.form.defaultLogisticsFlag = this.list.length === 0;
            }
          }
        });
    },
    /** 设置默认物流 */
    setDefaultLogistics() {
      const {
        businessId,
        businessCode,
        businessName,
        companyId,
        companyCode,
        companyName,
      } = this.defaultLogistics;
      this.form.logisticCompanyId = companyId;
      this.form.logisticCompanyCode = companyCode;
      this.form.logisticCompanyName = companyName;

      this.form.logisticBusinessId = businessId;
      this.form.logisticBusinessCode = businessCode;
      this.form.logisticBusinessName = businessName;
    },
    onRadio(v) {
      this.$refs.form.clearValidate();
      if (!v) {
        this.form = Object.assign({}, getDefaultForm());
      } else {
        this.setDefaultLogistics();
      }
      this.form.stockWarehouseId = this.stockId;
      this.form.stockWarehouseName = this.stockName;
      this.form.stockWarehouseCode = this.stockCode;
    },
    // 变更 物流商名称 时，需要重新选择 业务名称
    changeCompanyId(v) {
      const row = this.list.find(e => e.code === v);
      this.form.logisticCompanyId = row.id;
      this.form.logisticCompanyName = row.name;
      this.form.logisticBusinessCode = null;
    },
    changeBusinessCode(v) {
      const parent = this.list.find(e => e.code === this.form.logisticCompanyCode);
      const row = parent.businessList.find(e => e.code === v);
      this.form.logisticBusinessId = row.id;
      this.form.logisticBusinessName = row.name;
    },

    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.hide();
    },
    /** 上一步 */
    onLast() {
      this.hide();
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('confirm', this.form);
          this.hide();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
